import HistoryManager from './HistoryManager';

export default HistoryManager;
export * from './HistoryManager';
